
<ng-container *ngIf="isLoaded">
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Създаване на Потребител</h5>
        <p class="text-center small">Моля, въведете основните данни на потребителя</p>
      </div>

      <form [formGroup]="userForm" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="yourName" class="form-label">Име</label>
          <input type="text" formControlName="name" class="form-control" id="yourName">
        </div>
        <div class="col-12">
          <label for="yourSurname" class="form-label">Фамилия</label>
          <input type="text" formControlName="surname" class="form-control" id="yourSurname">
        </div>
        <div class="col-12">
          <label for="egn" class="form-label">ЕГН</label>
          <input type="text" formControlName="egn" class="form-control" id="egn">
        </div>
        <div class="form-group mt-4">
          <label for="responseType">Вид Обратна Връзка</label>
          <div class="payment-wrapper">
            <select class="form-control" id="responseType" formControlName="responseType">
              <option *ngFor="let method of responseTypes" [value]="method.value">
                {{GetCyrilicRequestType(method.value)}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12">
          <label for="yourUsername" class="form-label">Потребителско име</label>
          <div class="input-group has-validation">
            <span class="input-group-text">&#64;</span>
            <input type="text" formControlName="username" class="form-control" id="yourUsername">
          </div>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isService" id="isService">
            <label class="form-check-label" for="isService">Системен Акаунт</label>
          </div>
        </div>
        <div class="col-12">
          <label for="organization" class="form-label">Организация</label>
          <select formControlName="organization" class="form-select">
            <option value="" disabled selected>Изберете една от съществуващите Организации</option>
            <option *ngFor="let org of organizations" value="{{org.id}}">{{org.title}}</option>
          </select>
        </div>
        <div class="col-12">
          <label for="role" class="form-label">Роля</label>
          <select formControlName="role" class="form-select">
            <option value="" disabled>Изберете Роля</option>
            <option *ngFor="let role of roleTypes" [value]="UserRoleTypes[role]">{{ role.replace('_',' ') }}</option>
          </select>
        </div>
        <div class="col-12 mb-3">
          <label for="userProfession" class="form-label">Професия</label>
          <select formControlName="userProfession" class="form-select">
            <option value="" disabled selected>Изберете една от съществуващите Професии</option>
            <option *ngFor="let wg of userProfessions" [value]="wg.idUserProfession">{{wg.title}}</option>
          </select>
        </div>
        <div class="col-12">
          <label for="workingGroup" class="form-label">ВиК: Ремонта Група</label>
          <select formControlName="workingGroup" class="form-select">
            <option value="" disabled selected>Изберете една от съществуващите Ремонтни групи</option>
            <option *ngFor="let wg of workingGroups" value="{{wg.id}}">{{wg.title}}</option>
          </select>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!userForm.valid">Create Account</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
